/**
 * Version: 1.0.0
 * Description: Custom Scripts for Product Page Totem Road Flex 5.3.2
 * Author: Spherify Pty Ltd
 * Date: 10/04/2025
 */

window.addEventListener('load', function () {
    /**
     * Update the Add to Cart button with the correct total price
     */
    function updateButtonLabelWithPrice() {
        // Try multiple selectors for price element
        const priceElement = document.querySelector('.modal_price .price-ui .price .money[data-price]') ||
            document.querySelector('.price-ui .price .money[data-price]') ||
            document.querySelector('.price-ui .price .money') ||
            document.querySelector('.money[data-price]');
        const buttonLabelSpan = document.querySelector('.button--add-to-cart .text') ||
            document.querySelector('.add_to_cart .text');
        const quantityInput = document.querySelector('.quantity-input') ||
            document.querySelector('.quantity__input') ||
            document.querySelector('input[name="quantity"]');

        // If we're not on a product page or in a context where these elements should exist, return silently
        if (!document.querySelector('.product_form')) {
            return;
        }

        if (!priceElement || !buttonLabelSpan) {
            console.debug("Some elements not found for price update:", {
                priceElement: priceElement ? "Found: " + priceElement.textContent.trim() : "Missing",
                buttonLabelSpan: buttonLabelSpan ? "Found" : "Missing",
                quantityInput: quantityInput ? "Found" : "Not required"
            });
            return;
        }

        const priceText = priceElement.textContent.trim();
        const priceValue = parseFloat(priceText.replace(/[^\d.-]/g, ''));
        const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
        const totalPrice = (priceValue * quantity).toFixed(2);
        const currencySymbol = priceText.match(/[^\d.,]/)?.[0] || '$';
        buttonLabelSpan.innerHTML = `Add to Cart - ${currencySymbol}${totalPrice}`;
    }

    /**
     * Update delivery prompt message based on selected variant
     */
    function updateDeliveryPrompt(variantId) {
        const messageBox = document.getElementById('variant-delivery-message');
        if (!messageBox) return;

        if (window.varianZeroStrings && window.varianZeroStrings[variantId]) {
            messageBox.textContent = window.varianZeroStrings[variantId];
            messageBox.style.display = 'block';
        } else {
            messageBox.textContent = '';
            messageBox.style.display = 'none';
        }
    }

    /**
     * Watches <select name="id"> for changes (Flex uses this for final variant)
     */
    function observeVariantIdSelect() {
        const variantSelect = document.querySelector('select[name="id"]');
        if (!variantSelect) return;

        updateDeliveryPrompt(variantSelect.value);

        const observer = new MutationObserver(() => {
            updateDeliveryPrompt(variantSelect.value);
        });

        observer.observe(variantSelect, { attributes: true, attributeFilter: ['value'] });

        variantSelect.addEventListener('change', () => {
            updateDeliveryPrompt(variantSelect.value);
        });
    }

    /**
     * Watches <variant-selection> component for attribute changes
     */
    function observeVariantSelectionAttribute() {
        const variantSelection = document.querySelector('variant-selection');
        if (!variantSelection) return;

        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'variant') {
                    const newVariantId = variantSelection.getAttribute('variant');
                    if (newVariantId) {
                        updateDeliveryPrompt(newVariantId);
                    }
                }
            });
        });

        observer.observe(variantSelection, { attributes: true });
    }

    // Initial update with polling for price button
    let attempts = 0;
    const maxAttempts = 50; // 5 seconds
    const pollInterval = setInterval(() => {
        attempts++;

        updateButtonLabelWithPrice();

        if (attempts >= maxAttempts) {
            console.debug("Polling stopped after 5 seconds");
            clearInterval(pollInterval);
        }
    }, 100);

    // Watch for variant changes via <select name="id">
    const variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect) {
        variantSelect.addEventListener('change', updateButtonLabelWithPrice);
    }

    // Watch for radio button clicks
    const radioButtons = document.querySelectorAll('.swatch__option input[type="radio"]');
    radioButtons.forEach(radio => {
        radio.addEventListener('change', updateButtonLabelWithPrice);
    });

    // Watch for changes in the quantity input
    const quantityInput = document.querySelector('.quantity-input') ||
        document.querySelector('.quantity__input') ||
        document.querySelector('input[name="quantity"]');
    if (quantityInput) {
        quantityInput.addEventListener('input', updateButtonLabelWithPrice);
        quantityInput.addEventListener('change', updateButtonLabelWithPrice);
    }

    // Watch for quantity box updates
    document.addEventListener('click', (e) => {
        if (e.target.closest('.quantity-plus') || e.target.closest('.quantity-minus')) {
            updateButtonLabelWithPrice();
        }
    });

    // Watch for price changes in the DOM
    const priceContainer = document.querySelector('.modal_price .price-ui') || document.querySelector('.price-ui');
    if (priceContainer) {
        const observer = new MutationObserver(() => {
            setTimeout(updateButtonLabelWithPrice, 100);
        });
        observer.observe(priceContainer, { childList: true, subtree: true });
    }

    // PXUTheme Quantity Box Integration
    window.PXUTheme.quantityBox.updateQuantity = function ($el) {
        const $quantityBox = $el.parents('.product-quantity-box');
        const $input = $('.quantity-input', $quantityBox);
        let val = parseInt($input.val());
        let valMax = 100000000000000000;
        let valMin = $input.attr('min') || 0;
        if ($input.attr('max') != null) {
            valMax = $input.attr('max');
        }

        // Determine if this product should increment in boxes of 2 - custom.enable_qty_x2_units
        const enableQtyX2Units = $quantityBox.closest('[data-enable-qty-x2-units]').data('enable-qty-x2-units') === true;
        const incrementValue = enableQtyX2Units ? 2 : 1;
        const minThreshold = enableQtyX2Units ? 2 : valMin;

        if (val < minThreshold) {
            $input.val(minThreshold);
            val = minThreshold;
        } else if (val > valMax) {
            $input.val(valMax);
            val = valMax;
        }

        if ($el.data('update-quantity') === 'plus') {
            // Increase quantity input by incrementValue
            if (val < valMax) {
                val += incrementValue;
                // Ensure val doesn't exceed max
                val = Math.min(val, valMax);
                $input.val(val);
            }
        } else if ($el.data('update-quantity') === 'minus') {
            // Decrease quantity by incrementValue
            if (val > minThreshold) {
                val -= incrementValue;
                // Ensure val doesn't go below minThreshold
                val = Math.max(val, minThreshold);
                $input.val(val);
            }
        }

        // Update quantity if within cart (vs on the product page)
        if ($el.parents('[data-line-item]').length) {
            const lineID = $quantityBox.data('line-item-key');
            window.PXUTheme.quantityBox.updateCart(lineID, val);
        }

        // Call to update quantity controls
        window.PXUTheme.quantityBox.updateQuantityControls($el);

        // Trigger change event and update price
        $input.trigger('change');
        if (typeof updateButtonLabelWithPrice === 'function') {
            updateButtonLabelWithPrice();
        }
    };

    // Initial update
    updateButtonLabelWithPrice();
    observeVariantIdSelect();
    observeVariantSelectionAttribute();
});